import type { IUnmetContractRequirement, IWeekListByMonth } from '@/store/types';

import { MONTH_DAY_FORMAT } from '@/config/variables';
import { formatDate, getClosestDeadlineFormatted } from '@/helpers';

const formatWeekRange = (week: IWeekListByMonth): string =>
  `
  ${formatDate(new Date(week.startYear, week.startMonth - 1, week.startDay), MONTH_DAY_FORMAT)}
  -
  ${formatDate(new Date(week.endYear, week.endMonth - 1, week.endDay), MONTH_DAY_FORMAT)}
`;

const displayDeadline = (contract: IUnmetContractRequirement): string => getClosestDeadlineFormatted(contract);

export { formatWeekRange, displayDeadline };
